import CatLoader from '../components/CatLoader';
import { useState, useEffect } from 'react';
import api from '../api';

const CATEGORY_COLORS = {
  'Контент':           '#3b82f6',
  'Аналитика':         '#8b5cf6',
  'Статистика':        '#06b6d4',
  'Продвижение':       '#f59e0b',
  'Маркетплейс':       '#10b981',
  'Цены и скидки':     '#ef4444',
  'Вопросы и отзывы':  '#ec4899',
  'Поставки':          '#84cc16',
  'Финансы':           '#f97316',
  'Возвраты':          '#6b7280',
  'Документы':         '#a78bfa',
  'Чат с покупателями':'#14b8a6',
  'Пользователи':      '#fb7185',
};

function daysLeft(expiresAt) {
  if (!expiresAt) return null;
  return Math.ceil((new Date(expiresAt) - new Date()) / 86400000);
}

function ExpiryBadge({ expiresAt }) {
  const days = daysLeft(expiresAt);
  if (days === null) return null;
  const color = days <= 0 ? 'var(--red)' : days <= 14 ? 'var(--yellow)' : 'var(--green)';
  const label = days <= 0 ? 'Истёк' : days <= 14 ? `Истекает через ${days} дн.` : `${days} дн.`;
  return (
    <span style={{ fontSize:11, color, fontWeight:600,
      background:`${color}22`, padding:'2px 8px', borderRadius:20 }}>
      {label}
    </span>
  );
}

const inputStyle = {
  background:'var(--bg)', border:'1px solid var(--border)',
  color:'var(--text)', borderRadius:8, padding:'8px 12px',
  fontSize:13, outline:'none', boxSizing:'border-box',
};

const btnStyle = {
  padding:'6px 12px', fontSize:11, fontWeight:500,
  background:'transparent', color:'var(--text-muted)',
  border:'1px solid var(--border)', borderRadius:6, cursor:'pointer',
  whiteSpace:'nowrap',
};

export default function Profile() {
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [adding, setAdding] = useState(false);
  const [newName, setNewName] = useState('');
  const [newToken, setNewToken] = useState('');
  const [addError, setAddError] = useState('');
  const [checking, setChecking] = useState({});
  const [checkResults, setCheckResults] = useState({});

  useEffect(() => {
    api.get('/tokens').then(r => setTokens(r.data)).finally(() => setLoading(false));
  }, []);

  const handleAdd = async () => {
    setAddError('');
    if (!newToken.trim()) { setAddError('Вставьте токен'); return; }
    try {
      const r = await api.post('/tokens', { name: newName || 'WB Token', token: newToken.trim() });
      setTokens(prev => [r.data, ...prev]);
      setNewToken(''); setNewName(''); setAdding(false);
    } catch(e) {
      setAddError(e.response?.data?.error || 'Ошибка добавления');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Удалить токен?')) return;
    await api.delete('/tokens/' + id);
    setTokens(prev => prev.filter(t => t.id !== id));
  };

  const handleCheck = async (id) => {
    setChecking(prev => ({ ...prev, [id]: true }));
    try {
      const r = await api.post('/tokens/' + id + '/check');
      setCheckResults(prev => ({ ...prev, [id]: r.data.results }));
      setTokens(prev => prev.map(t => t.id === id ? { ...t, is_active: r.data.is_active } : t));
    } catch(e) {}
    setChecking(prev => ({ ...prev, [id]: false }));
  };

  const handleSetActive = async (id) => {
    try {
      await api.post('/tokens/' + id + '/set-active', { type: 'read' });
      alert('Токен установлен как активный для сервера');
    } catch(e) {
      alert(e.response?.data?.error || 'Ошибка');
    }
  };

  return (
    <>
      <CatLoader loading={loading}/>
      <div style={{ padding:28, maxWidth:900, color:'var(--text)' }}>
      <div style={{ marginBottom:24 }}>
        <div style={{ fontSize:20, fontWeight:700 }}>API токены Wildberries</div>
        <div style={{ fontSize:13, color:'var(--text-muted)', marginTop:4 }}>
          Управление токенами WB API. Токен действует 180 дней после создания.
        </div>
      </div>

      {!adding && (
        <button onClick={() => setAdding(true)} style={{
          marginBottom:20, padding:'8px 18px', fontSize:13, fontWeight:600,
          background:'var(--accent)', color:'#fff', border:'none',
          borderRadius:8, cursor:'pointer',
        }}>+ Добавить токен</button>
      )}

      {adding && (
        <div style={{ marginBottom:20, padding:20, background:'var(--surface)',
          border:'1px solid var(--border)', borderRadius:12 }}>
          <div style={{ fontSize:14, fontWeight:600, marginBottom:14 }}>Новый WB API токен</div>

          <div style={{ marginBottom:12 }}>
            <div style={{ fontSize:12, color:'var(--text-muted)', marginBottom:6 }}>Название (необязательно)</div>
            <input value={newName} onChange={e => setNewName(e.target.value)}
              placeholder="Например: Основной (чтение)"
              style={{ width:'100%', maxWidth:400, ...inputStyle }} />
          </div>

          <div style={{ marginBottom:8 }}>
            <div style={{ fontSize:12, color:'var(--text-muted)', marginBottom:6 }}>
              Токен WB API
              <a href="https://seller.wildberries.ru/api-integrations" target="_blank" rel="noreferrer"
                style={{ color:'var(--accent)', marginLeft:8, fontSize:11 }}>
                Получить токен →
              </a>
            </div>
            <textarea value={newToken} onChange={e => setNewToken(e.target.value)}
              placeholder="eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCJ9..."
              rows={3}
              style={{ width:'100%', maxWidth:700, ...inputStyle, resize:'vertical', fontFamily:'monospace', fontSize:11 }} />
          </div>

          <div style={{ fontSize:11, color:'var(--text-muted)', marginBottom:12 }}>
            💡 Для сайта создайте <b>Персональный токен</b> с категориями: Контент, Аналитика, Статистика, Продвижение — и выберите <b>Только чтение</b>
          </div>

          {addError && (
            <div style={{ color:'var(--red)', fontSize:12, marginBottom:10 }}>{addError}</div>
          )}

          <div style={{ display:'flex', gap:8 }}>
            <button onClick={handleAdd} style={{
              padding:'7px 16px', fontSize:13, fontWeight:600,
              background:'var(--accent)', color:'#fff', border:'none', borderRadius:7, cursor:'pointer',
            }}>Добавить</button>
            <button onClick={() => { setAdding(false); setAddError(''); setNewToken(''); setNewName(''); }} style={{
              padding:'7px 16px', fontSize:13, background:'transparent',
              color:'var(--text-muted)', border:'1px solid var(--border)', borderRadius:7, cursor:'pointer',
            }}>Отмена</button>
          </div>
        </div>
      )}

      {loading ? (
        <div style={{ color:'var(--text-muted)', fontSize:13 }}>Загрузка...</div>
      ) : tokens.length === 0 ? (
        <div style={{ padding:32, textAlign:'center', color:'var(--text-muted)',
          background:'var(--surface)', borderRadius:12, border:'1px dashed var(--border)' }}>
          <div style={{ fontSize:32, marginBottom:8 }}>🔑</div>
          <div style={{ fontSize:14 }}>Нет добавленных токенов</div>
          <div style={{ fontSize:12, marginTop:4 }}>Добавьте токен WB API для работы сайта</div>
        </div>
      ) : (
        <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
          {tokens.map(t => (
            <div key={t.id} style={{
              padding:16, background:'var(--surface)',
              border:'1px solid ' + (t.is_active ? 'rgba(16,185,129,0.3)' : 'var(--border)'),
              borderRadius:12,
            }}>
              <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', gap:12 }}>
                <div style={{ flex:1 }}>
                  <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:6, flexWrap:'wrap' }}>
                    <span style={{ fontSize:14, fontWeight:600 }}>{t.name}</span>
                    <span style={{
                      fontSize:10, fontWeight:700, padding:'2px 8px', borderRadius:20,
                      background: t.token_type === 'read' ? 'rgba(59,130,246,0.15)' : 'rgba(239,68,68,0.15)',
                      color: t.token_type === 'read' ? 'var(--accent)' : 'var(--red)',
                    }}>
                      {t.token_type === 'read' ? '👁 Только чтение' : '✏️ Чтение и запись'}
                    </span>
                    <span style={{
                      fontSize:10, padding:'2px 8px', borderRadius:20, fontWeight:600,
                      background: t.is_active ? 'rgba(16,185,129,0.15)' : 'rgba(239,68,68,0.15)',
                      color: t.is_active ? 'var(--green)' : 'var(--red)',
                    }}>
                      {t.is_active ? '● Активен' : '● Неактивен'}
                    </span>
                    <ExpiryBadge expiresAt={t.expires_at} />
                  </div>

                  <div style={{ fontSize:11, color:'var(--text-muted)', fontFamily:'monospace', marginBottom:8 }}>
                    {t.token_preview}
                  </div>

                  <div style={{ display:'flex', flexWrap:'wrap', gap:4, marginBottom:8 }}>
                    {(t.categories || []).map(cat => (
                      <span key={cat} style={{
                        fontSize:10, padding:'2px 8px', borderRadius:20,
                        background:(CATEGORY_COLORS[cat] || '#6b7280') + '22',
                        color: CATEGORY_COLORS[cat] || '#6b7280',
                        border:'1px solid ' + (CATEGORY_COLORS[cat] || '#6b7280') + '44',
                      }}>{cat}</span>
                    ))}
                  </div>

                  {checkResults[t.id] && (
                    <div style={{ display:'flex', flexWrap:'wrap', gap:4 }}>
                      {Object.entries(checkResults[t.id]).map(([cat, status]) => (
                        <span key={cat} style={{
                          fontSize:10, padding:'2px 8px', borderRadius:20,
                          background: status === 'ok' ? 'rgba(16,185,129,0.1)' : 'rgba(239,68,68,0.1)',
                          color: status === 'ok' ? 'var(--green)' : 'var(--red)',
                        }}>
                          {status === 'ok' ? '✓' : '✗'} {cat}
                        </span>
                      ))}
                    </div>
                  )}
                </div>

                <div style={{ display:'flex', flexDirection:'column', gap:6, flexShrink:0 }}>
                  <button onClick={() => handleCheck(t.id)} disabled={checking[t.id]} style={btnStyle}>
                    {checking[t.id] ? '...' : '🔍 Проверить'}
                  </button>
                  <button onClick={() => handleSetActive(t.id)}
                    style={{ ...btnStyle, color:'var(--green)', borderColor:'rgba(16,185,129,0.3)' }}>
                    ✓ Использовать
                  </button>
                  <button onClick={() => handleDelete(t.id)}
                    style={{ ...btnStyle, color:'var(--red)', borderColor:'rgba(239,68,68,0.2)' }}>
                    🗑 Удалить
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <div style={{ marginTop:28, padding:16, background:'rgba(59,130,246,0.05)',
        border:'1px solid rgba(59,130,246,0.15)', borderRadius:12 }}>
        <div style={{ fontSize:13, fontWeight:600, marginBottom:8 }}>📖 Как создать токен для сайта</div>
        <ol style={{ fontSize:12, color:'var(--text-muted)', lineHeight:1.7, paddingLeft:16, margin:0 }}>
          <li>Войдите в <a href="https://seller.wildberries.ru/api-integrations" target="_blank" rel="noreferrer"
            style={{ color:'var(--accent)' }}>личный кабинет WB → Интеграции по API</a></li>
          <li>Нажмите <b>+ Создать токен</b> → вкладка <b>Для интеграции вручную</b></li>
          <li>Выберите тип: <b>Персональный токен</b></li>
          <li>Отметьте категории: Контент, Аналитика, Статистика, Продвижение</li>
          <li>Уровень доступа: <b>Только чтение</b> (для безопасности)</li>
          <li>Нажмите <b>Создать</b>, скопируйте токен и вставьте выше</li>
        </ol>
      </div>
    </div>
    </>
  );
}